import { data } from "jquery";
import { stringify } from "qs";

const paging = {
  data() {
    return {
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件
      queryCondditionDatas: [], //查询列表动态数据
      originCondditionDatas: [],
      queryConddition: {}, // 查询列表map
      conditions: {}, // 初始化值
      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "75vh", //  表格高度
      selectTableData: [], //  表格选中的数据
      myTableHeard: [], //  我的表头
      tableData: [], //  表格数据
      tableDataAlias: [],
      tabelHeadeTitle: [], //默认表头
      show_sortTableHeard: false, //显示表格设置弹窗
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      allCheck: false, //  全选
      sortName: "模板", //  排序名
      selectLength: 0, //  显示的长度
      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      //      -------  表格  ----------
      // 标记表格是否已经构建完条件
      hadInited: false,
      // 是否马上查询数据
      immediate: false,
      conditionBackup: {},
      getApiType: false,
      conditionsMR: {},//默认值
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() { },
  mounted() {
    this.originCondditionDatas = this.queryCondditionDatas
    this.initTable();
  },
  // 每次进页面都会触发的写这里
  activated() {
    if (this.hadInited) {
      const keys = Object.keys(this.$route.query);
      if (keys.includes("refresh")) {
        this.refresh();
      }
    }
  },
  methods: {
    reset() {
      //this.queryConddition = JSON.parse(JSON.stringify(this.conditionBackup))
    },
    async getData(req) {
      let conditionReqs = [];
      for (let conditonKey in this.conditions) {
        const conditonVal = this.conditions[conditonKey];
        conditionReqs.push({
          conditonKey,
          conditonVal,
        });
      }
      if (this.$refs.queryForm) {
        let F_config = this.$refs.queryForm.F_config;
        F_config.forEach(async (element) => {
          let {
            textBoxType,
            conditonKey,
            dropdownSubmitField,
            conditonVal,
            defaultSelectVal,
            timeType,
            timeChilds,
            startTime_a,
            endTime_a,
            dropdownShowField,
            dropdownApiNumber,
          } = element;
          switch (textBoxType) {
            case "input":
              conditionReqs.push({
                conditonKey,
                conditonVal,
              });
              break;
            case "input_more":
              conditionReqs.push({
                conditonKey,
                conditonVal: conditonVal ? conditonVal.split(/[，,]/) : [],
              });
              break;
            case "select":
              conditionReqs.push({
                conditonKey: conditonKey,
                // conditonKey: dropdownSubmitField || conditonKey,
                conditonVal,
              });
              break;
            case "datetime":
              let curs = timeChilds[timeType];
              curs &&
                curs.children.forEach((element, index) => {
                  let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : "";
                  let startTime_agg = startTime_a
                    ? `${startTime_a} 00:00:00`
                    : "";
                  conditionReqs.push({
                    conditonKey: element.conditonKey,
                    conditonVal: index == 1 ? endTime_agg : startTime_agg,
                  });
                });
              break;
            case "date":
              let curs2 = timeChilds[timeType];
              curs2 &&
                curs2.children.forEach((element, index) => {
                  // let endTime_agg = endTime_a ? `${endTime_a}` : "";
                  // let startTime_agg = startTime_a ? `${startTime_a}` : "";
                  let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : "";
                  let startTime_agg = startTime_a
                    ? `${startTime_a} 00:00:00`
                    : "";
                  conditionReqs.push({
                    conditonKey: element.conditonKey,
                    conditonVal: index == 1 ? endTime_agg : startTime_agg,
                  });
                });
              break;
            default:
              conditionReqs.push({
                conditonKey,
                conditonVal,
              });
              break;
          }
        });
      }
      if (req) {
        for (let conditonKey in req) {
          conditionReqs.push({
            conditonKey,
            conditonVal: req[conditonKey],
          });
        }
      }
      // 解决后台空字符串当成0 的问题
      conditionReqs = conditionReqs.filter((item) => {
        return (
          item.conditonVal !== undefined &&
          item.conditonVal !== null &&
          item.conditonVal !== "" &&
          (!(item.conditonVal instanceof Array) || item.conditonVal.length > 0)
        );
      });
      let params = {
        conditionReqs,
        pageStart: this.pageStart || 0,
        pageTotal: this.pageTotal || 50,
        number: this.reportFiledsNumber,
      };
      await this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result.datas || {};
          this.className = datas.className || "";
          this.tableData = datas.data || [];
          this.pageCount = datas.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
            this.tableDataAlias = this.tableData
            this.$emit('fetched')
            this.fetched && this.fetched()
          });
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },
    async getDataOnly(req) {
      let conditionReqs = [];
      for (let conditonKey in this.conditions) {
        const conditonVal = this.conditions[conditonKey];
        conditionReqs.push({
          conditonKey,
          conditonVal,
        });
      }
      if (this.$refs.queryForm) {
        let F_config = this.$refs.queryForm.F_config;
        F_config.forEach(async (element) => {
          let {
            textBoxType,
            conditonKey,
            dropdownSubmitField,
            conditonVal,
            defaultSelectVal,
            timeType,
            timeChilds,
            startTime_a,
            endTime_a,
            dropdownShowField,
            dropdownApiNumber,
          } = element;
          switch (textBoxType) {
            case "input":
              conditionReqs.push({
                conditonKey,
                conditonVal,
              });
              break;
            case "input_more":
              conditionReqs.push({
                conditonKey,
                conditonVal: conditonVal ? conditonVal.split(",") : [],
              });
              break;
            case "select":
              conditionReqs.push({
                conditonKey: conditonKey,
                // conditonKey: dropdownSubmitField || conditonKey,
                conditonVal,
              });
              break;
            case "datetime":
              let curs = timeChilds[timeType];
              curs &&
                curs.children.forEach((element, index) => {
                  let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : "";
                  let startTime_agg = startTime_a
                    ? `${startTime_a} 00:00:00`
                    : "";
                  conditionReqs.push({
                    conditonKey: element.conditonKey,
                    conditonVal: index == 1 ? endTime_agg : startTime_agg,
                  });
                });
              break;
            case "date":
              let curs2 = timeChilds[timeType];
              curs2 &&
                curs2.children.forEach((element, index) => {
                  // let endTime_agg = endTime_a ? `${endTime_a}` : "";
                  // let startTime_agg = startTime_a ? `${startTime_a}` : "";
                  let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : "";
                  let startTime_agg = startTime_a
                    ? `${startTime_a} 00:00:00`
                    : "";
                  conditionReqs.push({
                    conditonKey: element.conditonKey,
                    conditonVal: index == 1 ? endTime_agg : startTime_agg,
                  });
                });
              break;
            default:
              conditionReqs.push({
                conditonKey,
                conditonVal,
              });
              break;
          }
        });
      }
      if (req) {
        for (let conditonKey in req) {
          const rrr = conditionReqs.filter(item => {
            return item.conditonKey == conditonKey
          })
          if(rrr.length > 0){
            rrr[0].conditonVal = req[conditonKey]
          }
          else{
            conditionReqs.push({
              conditonKey,
              conditonVal: req[conditonKey],
            });
          }
        }
      }
      // 解决后台空字符串当成0 的问题
      conditionReqs = conditionReqs.filter((item) => {
        return (
          item.conditonVal !== undefined &&
          item.conditonVal !== null &&
          item.conditonVal !== "" &&
          (!(item.conditonVal instanceof Array) || item.conditonVal.length > 0)
        );
      });
      let params = {
        conditionReqs,
        pageStart: this.pageStart || 0,
        pageTotal: this.pageTotal || 50,
        number: this.reportFiledsNumber,
      };
      const res = await this.$API.runPageReport(params)
      return res.data.result.datas || {}
    },
    async initTable(refresh) {
      if (refresh) {
        this.tableData = []
        this.selectTableData = []
        this.pageStart = 1
      }
      this.queryConddition = {}
      // //获取 所有页面 number
      await this.$API
        .getQueryList({
          number: "",
          reportName: "",
        })
        .then((res) => { });
      //获取当前页面已设置表头
      await this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          // if (arr.length > 0) {
          //   if (arr[0].sortObject) {
          //     this.tabelHeadeTitle = JSON.parse(arr[0].sortObject);
          //     this.sortName = arr[0].sortName;
          //   }
          // }
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            this.myTableHeard = [];
          }
          let totalArr = [];
          
          //提取需要合计的字段
          for (var i = 0; i < this.myTableHeard.length; i++) {
            if (this.myTableHeard[i].isTotal) {
              totalArr.push(this.myTableHeard[i].field);
            }
          }
          this.totalArr = totalArr;
        });
      //表格 表头默认
      await this.$API
        .getReportFileds({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          let lists = [];
          datas.forEach((element) => {
            lists.push({
              name: element.fieldNameShow,
              field: element.fieldAlias,
              width: element.wide,
              isTotal: element.isSum,
              sort: element.sort,
              isShow: element.isShow == 0 ? false : true,
              isSort: true,
            });
          });
          this.originalTabelHeadeTitle = lists;
          if (!this.tabelHeadeTitle.length) {
            this.tabelHeadeTitle = this.originalTabelHeadeTitle;
          }
        });
      if (this.myTableHeard.length == 0) {
        this.myTableHeard = this.tabelHeadeTitle;
      }
      let arrsConddition = [];
      // 获取查询条件 list
      await this.$API
        .getReportConditions({
          number: this.reportFiledsNumber,
        })
        .then((res) => {
          let datas = res.data.result || [];
          if (datas && datas.length > 0) {
            datas.map((n) => (n.conditonVal = n.conditonVal || ""));
            let arrs = datas.filter((n) => {
              return n.textBoxType === "datetime" && n.isShow;
            });
            let timeobjs = {};
            arrs.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs[sort]) {
                timeobjs[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs[sort].children.push(item);
            });
            let gdates = [];
            let dates = Object.values(timeobjs);
            if (dates.length) {
              gdates = [
                {
                  textBoxType: "datetime",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                  isShow: 1,
                },
              ];
            }

            let arrs2 = datas.filter((n) => {
              return n.textBoxType === "date" && n.isShow;
            });
            let timeobjs2 = {};
            arrs2.forEach((item) => {
              let { sort, conditonKeyShow } = item;
              let name = conditonKeyShow.includes("起始")
                ? conditonKeyShow.split("起始").join("")
                : conditonKeyShow.split("结束").join("");
              if (!timeobjs2[sort]) {
                timeobjs2[sort] = {
                  sort,
                  name,
                  children: [],
                };
              }
              timeobjs2[sort].children.push(item);
            });

            let gdates2 = [];
            let dates2 = Object.values(timeobjs2);
            if (dates2.length) {
              gdates2 = [
                {
                  textBoxType: "date",
                  startTime_a: this.$TOOLS.getFlexDate(this.$COMMON.timeNum),
                  endTime_a: this.$TOOLS.getCurrentDate(),
                  timeType: "0",
                  timeTypes: dates2.map((n, i) => {
                    return { value: String(i), label: n.name };
                  }),
                  timeChilds: dates2.map((n, i) => {
                    return { sort: n.sort, name: n.name, children: n.children };
                  }),
                  isShow: 1,
                },
              ];
            }
            arrsConddition = [
              ...gdates,
              ...gdates2,
              ...datas.filter((n) => {
                return n.textBoxType !== "datetime" && n.textBoxType !== "date";
              }),
            ];
          }
        });
      // 获取 每个查询条件 的下拉数据
      const promisemap = arrsConddition.map(async (element, index) => {
        let {
          textBoxType,
          dropdownShowField,
          dropdownApiNumber,
          conditonVal,
          defaultSelectVal,
          isDefaultCurrentDept
        } = element;
        if (textBoxType == "select") {
          let selectOptions = [];
          if (conditonVal || defaultSelectVal) {
            await this.$API
              .runListReport({
                conditionReqs: [
                  {
                    conditonKey: dropdownShowField,
                    conditonVal: "",
                  },
                ],
                number: dropdownApiNumber
              })
              .then((res) => {
                let datas = res || [];
                selectOptions = datas;
              });
            element.conditonVal = conditonVal || defaultSelectVal || "";
          }
          element.selectOptions = selectOptions;
        }
        if(isDefaultCurrentDept===1){
          if (textBoxType === "dept_tree" || textBoxType === "select_more" || textBoxType === "dept_tree_strict") {
            element.conditonVal = [this.$TOOLS.getUserInfo().departmentId];
          }else{
            element.conditonVal=this.$TOOLS.getUserInfo().departmentId;
          }
          console.log("departmentName", this.$TOOLS.getUserInfo().departmentName)
          element.defaultSelectVal=this.$TOOLS.getUserInfo().departmentId;
          element.defaultSelectShow=this.$TOOLS.getUserInfo().departmentName;
        }
      });
      await Promise.all(promisemap);
      const originCondition = [...this.originCondditionDatas];
      if (this.conditionsMR) {
        for (var k in this.conditionsMR) {
          for (var a = 0; a < arrsConddition.length; a++) {
            if (arrsConddition[a].conditonKey == k) {
              if (arrsConddition[a].textBoxType == "dept_tree") {
                arrsConddition[a].conditonVal = [this.conditionsMR[k]]
              }


            }
          }
        }

      }
      this.queryCondditionDatas = arrsConddition;
      for (let item of arrsConddition) {
        if (!item.conditonKey) {
          const children = item.timeChilds;
          if (!children) {
            continue
          }
          this.queryConddition["timeType"] = item;
          for (let i = 0; i < children.length; i++) {
            const child = children[i];
            const children2 = child.children;
            if (!children2) {
              continue
            }
            for (let child2 of children2) {
              child2.timeType = item;
              child2.pos = i;
              this.queryConddition[child2.conditonKey] = child2;
            }
          }
          continue;
        }
        this.queryConddition[item.conditonKey] = item;
      }
      originCondition.map((item) => {
        const con = this.queryCondditionDatas.filter(
          (item2) => item2.conditonKey === item.conditonKey
        );
        if (con && con.length == 1) {
          con[0].conditonVal = item.conditonVal;
        } else {
          const newOne = { ...item }
          this.queryCondditionDatas.push(newOne);
          this.queryConddition[item.conditonKey] = newOne
        }
      });
      for (let conditonKey in this.conditions) {
        const conditonVal = this.conditions[conditonKey];
        this.queryCondditionDatas.push({
          conditonKey,
          conditonVal,
        });
        if (!this.queryConddition[conditonKey]) {
          this.queryConddition[conditonKey] = {
            conditonKey,
            conditonVal,
          };
        } else {
          this.queryConddition[conditonKey].conditonVal = conditonVal;
        }
      }
      // this.fetTableHeight();
      // setTimeout(() => {
      //   this.queryBtn_ok();
      // }, 0);
      this.$nextTick(() => {
        this.fetTableHeight();
        this.ready && this.ready()
        if (this.immediate) {
          this.queryBtn_ok();
        }
      });
      this.hadInited = true;
      // 重置参数用


    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      // 弃用
      return false;
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    fetched() { },
    clerBtns(refresh) {
      //  重置按钮
      this.initTable(refresh);
    },
    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },
    refresh() {
      this.queryBtn_ok();
    },
    // 设置条件
    setCondition(key, val) {
      const condition = this.queryConddition[key];
      if (!condition) {
        return;
      }
      condition.conditonVal = val;
      const timeType = condition.timeType;
      if (timeType) {
        const pos = condition.pos;
        timeType.timeType = pos + "";
        if (key.startsWith("start")) {
          timeType.startTime_a = val;
        } else {
          timeType.endTime_a = val;
        }
      }
    },
    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList
        ? this.$refs.btnList.offsetHeight
        : 0; // 按钮列表高度
      if (this.isHaseMore && this.$refs.queryForm) {
        queryHeigth = this.$refs.queryForm.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        // this.$refs.mytable.doLayout();
      });
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
      }
      if (a === "dtdc") {
        // 动态列表的导出
        this.isShowDialog_dc = true;
      }
      if (a === "printBtns") {
        this.printEvent();
      }
    },

    topCommandBtnsBak(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
        return true;
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
        return true;
      }
      if (a === "dtdc") {
        // 动态列表的导出
        this.isShowDialog_dc = true;
        return true;
      }
      if (a === "printBtns") {
        this.printEvent();
        return true;
      }
    },

    bgszFn() {
      this.$TOOLS.myModel(this);
    },

    printSetting() {
      if (this.$refs.myPrint) {
        this.$refs.myPrint.printEvent(this.selectTableData,true)
        return
      }
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // let idarr = this.selectTableData.map((item) => {
        //   return item.waybillSplitId;
        // });
        // window.sessionStorage.setItem(
        //   "set_PrintSelectTableData",
        //   JSON.stringify(idarr)
        // );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // 打印
    printEvent(row) {
      if (this.$refs.myPrint) {
        this.$refs.myPrint.printEvent(row ? [row] : this.selectTableData)
        return
      }
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // let idarr = this.selectTableData.map((item) => {
        //   return item.waybillSplitId;
        // });
        // window.sessionStorage.setItem(
        //   "set_PrintSelectTableData",
        //   JSON.stringify(idarr)
        // );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // 直接打印
    printEventNow(row) {
      if (this.$refs.myPrint) {
        this.$refs.myPrint.printEventNow(row ? [row] : this.selectTableData)
        return
      }
      if (this.selectTableData.length < 1) {
        this.$confirm("还没有选择需要打印的数据源,是否新建模板?", "提示:", {
          confirmButtonText: "新建模板",
          cancelButtonText: "关闭",
        }).then((res) => {
          if (res == "confirm") {
            this.handleCreated();
          } else {
            // this.$message.error("请选择需要打印的数据源");
            // return false;
          }
        });
      } else {
        // let idarr = this.selectTableData.map((item) => {
        //   return item.waybillSplitId;
        // });
        // window.sessionStorage.setItem(
        //   "set_PrintSelectTableData",
        //   JSON.stringify(idarr)
        // );
        this.dialogFrom.dialogVisible = true;
      }
    },

    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        // this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      };
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName);
      });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        // this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    doLayout(){
      this.$refs.mytable.doLayout();
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
    getRowIndex(row) {
      const pos = this.tableData.indexOf(row);
      return pos;
    },
    // 点击表格字段出发时间
    fildsClick(row, field) {
      const name = field + 'ClickHandler'
      const fun = this[name]
      if (fun && fun instanceof Function) {
        fun(row)
      }
    },
    fieldDbClick(row, field) {
      const name = field + 'DbClickHandler'
      const fun = this[name]
      if (fun && fun instanceof Function) {
        fun(row)
      }
    }
  },
};

export default paging;
